import api from '@/api/fyApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_GOSPEL_BOOK, LOAD_GOSPEL_HOME, SEO } from '../protocols';

export interface State {
    book: {
        "id": number,
        "category_id": number,
        "title": string,
        "thumb": string,
        "author": string,
        "intro": string,
        "level": number,
        "listorder": number,
        "status": number,
        "hits": number,
        "items": number
        "createtime": number,
        "updatetime": number,
        "category": {
            "type_text": string,
            "flag_text": string,
            "id": number,
            "name": string,
            "type": string,
            "flag": string
        },
        "articles": Array<
            {
                "id": number,
                "book_id": number,
                "title": string,
                "listorder": number
            }
        >
    },
    article: {
        "id": number,
        audio_url: string,
        "book_id": number,
        "title": string
        "content": string
        "status": number,
        "listorder": number,
        "hits": number,
        "createtime": number,
        "updatetime": number
    }
}

class GospelBook extends BaseModule<State> {
    constructor() {
        super(LOAD_GOSPEL_BOOK[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                book: {
                    id: 0,
                    "category_id": 0,
                    "title": '',
                    "thumb": '',
                    "author": '',
                    "intro": '',
                    "level": 0,
                    "listorder": 0,
                    "status": 0,
                    "hits": 0,
                    "items": 0,
                    "createtime": 0,
                    "updatetime": 0,
                    "category": {
                        "type_text": '',
                        "flag_text": '',
                        "id": 0,
                        "name": '',
                        "type": '',
                        "flag": ''
                    },
                    "articles": []
                },
                article: {
                    id: 0,
                    audio_url: '',
                    "book_id": 0,
                    "title": '',
                    "content": '',
                    "status": 0,
                    "listorder": 0,
                    "hits": 0,
                    "createtime": 0,
                    "updatetime": 0,
                }
            },
            actions: {
                async loadData({ state, dispatch, commit }, route: Route) {
                    let id = parseInt(route.params.id)
                    if (state.book.id != id) {
                        state.book = await api.getGospelBook(id)
                    }
                    let aid = parseInt(route.query.aid)
                    if (state.book.articles.length > 0) {
                        if (!state.book.articles.some(item => item.id == aid)) {
                            aid = state.book.articles[0].id
                        }
                        if (state.article.id != aid) {
                            state.article = await api.getGospelBookChapter(aid)
                        }
                        const seoTitle = `福音信息-${state.article.title}-福音影视网|福音TV`
                        commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    } else {
                        state.article = {
                            id: 0,
                            audio_url:'',
                            "book_id": 0,
                            "title": '',
                            "content": '',
                            "status": 0,
                            "listorder": 0,
                            "hits": 0,
                            "createtime": 0,
                            "updatetime": 0,
                        }
                        const seoTitle = `福音信息-${state.book.title}-福音影视网|福音TV`
                        commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    }
                },
                [LOAD_GOSPEL_BOOK[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '福音信息-一起看-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch('loadData', route),
                        dispatch(LOAD_GOSPEL_HOME[0] + '/loadCategory', route, { root: true })
                    ])
                }
            }
        }
    }
}

export default new GospelBook();